<template>
	<div class="asp-right-container">
		<template v-if="showAds">
			<div class="asp-right-images m-3">
				<img
					class="h-100 w-100"
					src="../../assets/mobile/assprog/videoResume.svg"
					alt=""
				/>
			</div>
			<div class="asp-right-images m-3">
				<img
					class="h-100 w-100"
					src="../../assets/mobile/assprog/course.svg"
					alt=""
				/>
			</div>
			<div class="asp-right-images m-3">
				<img
					class="h-100 w-100"
					src="../../assets/mobile/assprog/jobInterview.svg"
					alt=""
				/>
			</div>
		</template>
		<template v-else>
			<div class="d-flex candash-reume-header pl-3">
				<div
					@click="currentTab = COMPLETED"
					:class="showCompleted ? 'asp-sel-tab' : 'asp-unsel-tab'"
				>
					<span>Completed </span>
					<div v-if="showCompleted" class="asp-sel-line"></div>
				</div>
				<div
					@click="currentTab = UPCOMING"
					:class="showUpcoming ? 'asp-sel-tab' : 'asp-unsel-tab'"
				>
					<span>Upcoming </span>
					<div v-if="showUpcoming" class="asp-sel-line"></div>
				</div>
				<div
					@click="currentTab = ONGOING"
					:class="showOngoing ? 'asp-sel-tab' : 'asp-unsel-tab'"
				>
					<div>Ongoing</div>
					<div v-if="showOngoing" class="asp-sel-line"></div>
				</div>
			</div>
			<div v-if="loaderSide" class="asp-right-overflow">
				<div
					v-for="(assess, index) in assessShimmer"
					:key="index"
					class="assesspro-cards-blue"
				>
					<div class="d-flex">
						<div style="height: 35px; width: 35px">
							<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
						</div>
						<div class="width-93 3 pl-2">
							<b-skeleton class="w-50"></b-skeleton>
							<b-skeleton class="w-75 mt-2"></b-skeleton>
							<b-skeleton class="w-100 mt-2"></b-skeleton>
						</div>
					</div>
					<hr />
					<div class="w-100">
						<b-skeleton class="w-100"></b-skeleton>
					</div>
				</div>
			</div>
			<div v-else-if="showCompleted" class="asp-right-overflow">
				<div v-if="completedAssessments && completedAssessments.length">
					<div
						v-for="(assessment, index) in completedAssessments"
						:key="index"
						class="assesspro-cards-blue"
					>
						<div class="asp-top-card">
							<div class="asp-white-timer">
								<img
									class="mr-1"
									src="../../assets/newdesign/assessPro/sandClock.svg"
									alt=""
								/>
								{{ assessment.config.testDuration }} Min(s)
							</div>
							<div>
								<img src="../../assets/newdesign/assessPro/assDP.svg" alt="" />
							</div>
							<div class="pl-2 width-93 4">
								<div class="asp-card-head-txt text-truncate w70">
									<span
										class="text-capitalize"
										v-b-tooltip.hover="{ title: assessment.testName }"
									>
										{{ assessment.testName }}</span
									>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.categoryTitle"
								>
									<span class="asp-grey-txt-light">Category :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span
											v-b-tooltip.hover="{ title: assessment.categoryTitle }"
											>{{ assessment.categoryTitle }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Topic Name :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.topicName }">{{
											assessment.topicName
										}}</span>
									</div>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.companyName"
								>
									<span class="asp-grey-txt-light">Company :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.companyName }">
											{{ assessment.companyName }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Organiser :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.organiser }">
											{{ assessment.organiser }}</span
										>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-between mt-2">
							<div
								class="d-flex align-items-center asp-blue-txt pointer"
								@click="viewMarks(assessment, assessment?.config.test)"
							>
								<img
									class="mr-2"
									src="../../assets/newdesign/assessPro/viewMark.svg"
									alt=""
								/>
								View Marks
							</div>
							<div
								v-if="assessment.attemptsLeft != 0"
								@click="viewTestDetails(assessment, 'private')"
								class="d-flex align-items-center asp-blue-txt pointer"
							>
								{{ assessment.attemptsLeft }} Attempts left
								<img
									class="ml-1"
									src="../../assets/newdesign/assessPro/blueRightArrow.svg"
									alt=""
								/>
							</div>
							<div v-else class="asp-green-txt pr-3">Completed</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="h-100 d-flex flex-column align-items-center justify-content-center"
				>
					<img src="../../assets/newdesign/assessPro/noassessment.svg" alt="" />
					<span class="uploadDocs-caution-font text-center mt-3"
						>Currently, there are no completed <br />tests</span
					>
				</div>
			</div>
			<div v-else-if="showUpcoming" class="asp-right-overflow">
				<div v-if="upcomingAssessments && upcomingAssessments.length">
					<div
						v-for="(assessment, index) in upcomingAssessments"
						:key="index"
						class="assesspro-cards-blue"
					>
						<div class="asp-top-card">
							<div class="asp-white-timer">
								<img
									class="mr-1"
									src="../../assets/newdesign/assessPro/sandClock.svg"
									alt=""
								/>
								{{ assessment.testDuration }} Min(s)
							</div>
							<div>
								<img src="../../assets/newdesign/assessPro/assDP.svg" alt="" />
							</div>
							<div class="pl-2 width-93 5">
								<div class="d-flex align-items-center justify-content-between">
									<div class="asp-card-head-txt text-truncate w-75">
										<span
											class="text-capitalize"
											v-b-tooltip.hover="{ title: assessment.testName }"
											>{{ assessment.testName }}</span
										>
									</div>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.categoryTitle"
								>
									<span class="asp-grey-txt-light">Category :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span
											v-b-tooltip.hover="{ title: assessment.categoryTitle }"
											>{{ assessment.categoryTitle }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Topic Name :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.topicName }">{{
											assessment.topicName
										}}</span>
									</div>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.companyName"
								>
									<span class="asp-grey-txt-light">Company :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.companyName }">
											{{ assessment.companyName }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Organiser :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.organiser }">
											{{ assessment.organiser }}</span
										>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-between mt-2">
							<div class="d-flex align-items-center asp-blue-txt">
								<img
									class="mr-2"
									src="../../assets/newdesign/assessPro/smallCalen.svg"
									alt=""
								/>
								<span class="asp-small-grey-txt">Start date :&nbsp;</span
								><span class="mb-mobile-txt"
									>{{ formatTime(assessment.config.openTestdt) }},
									{{ formatDate(assessment.config.openTestdt) }}</span
								>
							</div>
							<div
								class="d-flex align-items-center asp-blue-txt pointer"
								@click="viewTestDetails(assessment, 'private')"
							>
								{{ isUpcoming(assessment) ? "Take Test" : "Take Test" }}
								<img
									class="ml-1"
									src="../../assets/newdesign/assessPro/blueRightArrow.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="h-100 d-flex flex-column align-items-center justify-content-center"
				>
					<img src="../../assets/newdesign/assessPro/noassessment.svg" alt="" />
					<span class="uploadDocs-caution-font text-center mt-3"
						>Currently, there are no upcoming <br />tests</span
					>
				</div>
			</div>
			<div v-else-if="showOngoing" class="asp-right-overflow">
				<div v-if="ongoingAssessments && ongoingAssessments.length">
					<div
						v-for="(assessment, index) in ongoingAssessments"
						:key="index"
						class="assesspro-cards-blue"
					>
						<div class="asp-top-card">
							<div class="asp-white-timer">
								<img
									class="mr-1"
									src="../../assets/newdesign/assessPro/sandClock.svg"
									alt=""
								/>
								{{ assessment.config.testDuration }} Min(s)
							</div>
							<div>
								<img src="../../assets/newdesign/assessPro/assDP.svg" alt="" />
							</div>
							<div class="pl-2 width-93 6">
								<div class="d-flex align-items-center justify-content-between">
									<div class="asp-card-head-txt text-truncate w-75">
										<span
											class="text-capitalize"
											v-b-tooltip.hover="{ title: assessment.testName }"
										>
											{{ assessment.testName }}</span
										>
									</div>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.categoryTitle"
								>
									<span class="asp-grey-txt-light">Category :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span
											v-b-tooltip.hover="{ title: assessment.categoryTitle }"
											>{{ assessment.categoryTitle }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Topic Name :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.topicName }">{{
											assessment.topicName
										}}</span>
									</div>
								</div>
								<div
									class="d-flex align-items-center mt-1"
									v-if="assessment.companyName"
								>
									<span class="asp-grey-txt-light">Company :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span
											v-b-tooltip.hover="{ title: assessment.companyName }"
											>{{ assessment.companyName }}</span
										>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1" v-else>
									<span class="asp-grey-txt-light">Organiser :</span>
									<div class="asp-grey-txt text-truncate ml-2 w60">
										<span v-b-tooltip.hover="{ title: assessment.organiser }">
											{{ assessment.organiser }}</span
										>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-between mt-2">
							<div class="d-flex align-items-center asp-blue-txt">
								<img
									class="mr-2"
									src="../../assets/newdesign/assessPro/smallCalen.svg"
									alt=""
								/>
								<span class="asp-small-grey-txt">Start date :&nbsp;</span
								><span class="mb-mobile-txt">
									{{ formatTime(assessment.config.openTestdt) }},
									{{ formatDate(assessment.config.openTestdt) }}
								</span>
							</div>
							<div
								@click="viewTestDetails(assessment, 'private')"
								class="d-flex align-items-center asp-blue-txt pointer"
							>
								Re-join
								<img
									class="ml-1"
									src="../../assets/newdesign/assessPro/blueRightArrow.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="h-100 d-flex flex-column align-items-center justify-content-center"
				>
					<img src="../../assets/newdesign/assessPro/noassessment.svg" alt="" />
					<span class="uploadDocs-caution-font text-center mt-3"
						>Currently, there are no ongoing <br />tests</span
					>
				</div>
			</div>
		</template>
		<AssessmentMarksModal
			:showMarks="showAssessmentMarks"
			:selectedAssessment="selectedAssessment"
			:isPublic="isPublic"
			@closeModal="showAssessmentMarks = false"
			@take-next-attempt="
				viewTestDetails(
					selectedAssessment,
					isPublic == true ? 'public' : 'private'
				)
			"
		/>
		<TestDetails
			v-if="showTestDetails"
			:showTestDetails="showTestDetails"
			:selectedAssessment="selectedAssessment"
			:public="isPublic"
			@closeTestModal="showTestDetails = false"
		/>
	</div>
</template>

<script>
import assessmentProgress from "../mixin/assessmentProgress";
import ProgressBar from "@/components/ProgressBar.vue";
import AssessmentMarksModal from "@/views/AssessmentProgress/AssessmentMarksModal.vue";
import TestDetails from "@/views/AssessmentProgress/TestDetailsAP.vue";

export default {
	name: "SidePanel",
	components: {
		ProgressBar,
		AssessmentMarksModal,
		TestDetails,
	},
	mixins: [assessmentProgress],
	created() {
		this.loaderSide = true;
		this.getAllAssessments();
	},
};
</script>

<style>
.assesspro-cards {
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: none;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
}

.asp-top-card {
	border-bottom: 1px solid #d9d9d9;
	padding-bottom: 13px;
	display: flex;
	align-items: flex-start;
	width: 100%;
	position: relative;
}

.assesspro-cards-blue {
	background: #e9f0f5;
	border: none;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
}

.asp-completed-tag {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: var(--cv-green);
	background-color: #f6f9fb;
	border-radius: 8px;
	padding: 1px 19px;
}

.asp-when-no-tab {
	height: calc(100vh - 148px);
	overflow: auto;
	padding: 15px;
}

.asp-when-no-tab::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.asp-when-no-tab {
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}

.asp-sel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #20639b;
	padding: 12px 14px;
	position: relative;
	cursor: pointer;
}

.asp-unsel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #000000;
	padding: 12px 14px;
	cursor: pointer;
}

.asp-sel-line {
	position: absolute;
	height: 4px;
	width: 100%;
	border-radius: 12px;
	background-color: #20639b;
	bottom: 0px;
	left: 0px;
}

.asp-right-overflow {
	padding: 12px 12px 0px 12px;
	overflow: auto;
	height: calc(100vh - 200px);
}

.asp-white-timer {
	border-radius: 7px;
	background-color: #ffffff;
	padding: 3px 6px;
	position: absolute;
	font-family: "Lato", sans-serif;
	font-size: 11px;
	font-weight: 600;
	color: #3a3c40;
	display: flex;
	align-items: center;
	right: -7px;
	top: -8px;
}

.greytool-box {
	background: #20639b30;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	height: 22px;
	width: 30px;
	left: 0px;
	top: 0px;
	border-radius: 7px 10px 10px 0px;
}

.greytool-box:hover {
	box-shadow: 0px 1px 4px 0px #00000026;
}

.asp-right-modal-overflow {
	max-height: calc(100vh - 580px);
	overflow: auto;
}

.asp-testdetails-bluebox {
	border-radius: 12px;
	background-color: #f6f9fb;
}

.asp-modal-blue-card {
	border-radius: 14px;
	background: #f2f7fb;
	padding: 20px;
	display: flex;
	flex-wrap: wrap;
	/* height: 420px; */
}

.asp-modal-blue-card > * {
	flex: 1 1 50%;
}

#asp-greytool .arrow::before {
	right: -150px !important;
	border-width: 0.4rem 0.4rem 0.4rem 0.4rem !important;
	border-left-color: #d9d9d9 !important;
	border-right-color: transparent !important;
}

#asp-greytool {
	top: 6px !important;
	left: -187px !important;
}

#asp-greytool .tooltip-inner {
	text-align: left !important;
	padding: 10px;
}
</style>
